module.exports = __webpack_public_path__ + "static/img/m1.100cdb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m1.jpg
// module id = HZwO
// module chunks = 1